import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f4b3efa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "btn-container d-flex align-items-center justify-content-end py-16" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-add me-12" }, null, -1))
const _hoisted_3 = {
  key: 0,
  class: "empty-state py-8 px-12 text-center"
}
const _hoisted_4 = { class: "h-100 w-100 d-flex flex-column align-items-center justify-content-center text-center" }
const _hoisted_5 = { class: "h5 title text-primary" }
const _hoisted_6 = {
  key: 1,
  class: "row row-cols-4 row-cols-lg-6 gy-20"
}
const _hoisted_7 = { class: "file-container h-100" }
const _hoisted_8 = { class: "file d-flex align-items-center justify-content-start flex-column text-decoration-none h-100" }
const _hoisted_9 = {
  key: 0,
  class: "icon icon-pdf mb-16"
}
const _hoisted_10 = ["alt", "src"]
const _hoisted_11 = {
  key: 2,
  class: "icon icon-doc mb-16"
}
const _hoisted_12 = { class: "d-flex flex-column justify-content-between" }
const _hoisted_13 = { class: "text file-name text-center text-sm mb-0" }
const _hoisted_14 = { class: "text text-center text-sm mb-0" }
const _hoisted_15 = ["aria-label", "title", "onClick"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-view-light mb-16" }, null, -1))
const _hoisted_17 = { class: "text text-white text-center fw-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_button = _resolveComponent("v-button")!
  const _component_the_patient_document_upload = _resolveComponent("the-patient-document-upload")!
  const _component_v_loader = _resolveComponent("v-loader")!
  const _component_the_patient_document_show_modal = _resolveComponent("the-patient-document-show-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.can('patient.expedient.file.store'))
        ? (_openBlock(), _createBlock(_component_v_button, {
            key: 0,
            "aria-label": _ctx.$t('Previsualizar documento'),
            variant: "secondary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showAddMedia = !_ctx.showAddMedia))
          }, {
            default: _withCtx(() => [
              _hoisted_2,
              _createTextVNode(" " + _toDisplayString(_ctx.$t(' Añadir documento')), 1)
            ]),
            _: 1
          }, 8, ["aria-label"]))
        : _createCommentVNode("", true)
    ]),
    (!!_ctx.showAddMedia)
      ? (_openBlock(), _createBlock(_component_the_patient_document_upload, {
          key: 0,
          onMediaConfirm: _ctx.mediaConfirm
        }, null, 8, ["onMediaConfirm"]))
      : _createCommentVNode("", true),
    (_ctx.status === 'loaded')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (!_ctx.media.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('No hay documentos de esta categoría')), 1)
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.media, (file) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: file.id,
                    class: "col"
                  }, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        (file.type === 'pdf')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_9))
                          : (file.type === 'image')
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 1,
                                alt: file.name,
                                src: file.storageUrl,
                                class: "w-50 mb-16"
                              }, null, 8, _hoisted_10))
                            : (_openBlock(), _createElementBlock("span", _hoisted_11)),
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("p", _hoisted_13, _toDisplayString(file.name), 1),
                          _createElementVNode("p", _hoisted_14, _toDisplayString(file.createdAt), 1)
                        ])
                      ]),
                      _createElementVNode("a", {
                        "aria-label": _ctx.$t('Previsualizar documento'),
                        class: "file-hover align-items-center flex-column text-decoration-none h-100 justify-content-center",
                        title: _ctx.$t('Previsualizar documento'),
                        onClick: _withModifiers(($event: any) => {_ctx.currentMedia = file; _ctx.modalToShow = 'the-patient-document-show-modal'}, ["prevent"])
                      }, [
                        _hoisted_16,
                        _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('Previsualizar documento')), 1)
                      ], 8, _hoisted_15)
                    ])
                  ]))
                }), 128))
              ]))
        ], 64))
      : (_openBlock(), _createBlock(_component_v_loader, { key: 2 })),
    (_ctx.modalToShow === 'the-patient-document-show-modal')
      ? (_openBlock(), _createBlock(_component_the_patient_document_show_modal, {
          key: 3,
          media: _ctx.currentMedia,
          onClosed: _cache[1] || (_cache[1] = ($event: any) => {_ctx.modalToShow = null; _ctx.currentMedia = null})
        }, null, 8, ["media"]))
      : _createCommentVNode("", true)
  ], 64))
}